import React from "react";

const getText = (
  adminWardName,
  postalCode,
  flatNumber,
  routeName,
  isPostalCode
) => {
  let text;
  if (postalCode || routeName) {
    if (isPostalCode || !routeName) {
      text = postalCode;
    } else {
      if (flatNumber) {
        text = `${flatNumber} ${routeName}`;
      } else {
        text = routeName;
      }
    }
  } else {
    text = adminWardName;
  }
  return text;
};
const Breadcrumbs = ({
  query,
  adminWardName,
  isPostalCode,
  routeName,
  flatNumber,
  postalCode,
  capitalizeFirstLetter,
  href
}) => (
  <div className="container">
    {(query && (
      <div>
        <div className="hide-xs">
          <div className="search-breadcrumb d-flex align-items-center">
            <a href="/">Homepage</a>
            <span> / </span>
            <a href={href}>
              {(adminWardName && `${flatNumber || ""} ${adminWardName}`) ||
                postalCode}{" "}
              Restaurants
            </a>
            <span> / </span>
            <a href="/search">{capitalizeFirstLetter(query)}</a>
          </div>
        </div>
        <div className="white-bg search-breadcrumb d-flex align-items-center justify-content-between visible-xs">
          <p>{query}</p>
          <a className="close" href="/search">
            <i className="icon icon-close visible-xs" />
          </a>
        </div>
      </div>
    )) || (
      <div className="breadcrumbs hide-xs">
        <a href="/">Homepage </a> &nbsp;/{" "}
        <a href="javascript:void(0)" className="active">
          {getText(
            adminWardName,
            postalCode,
            flatNumber,
            routeName,
            isPostalCode
          )}{" "}
          Restaurants
        </a>
      </div>
    )}
  </div>
);

export default Breadcrumbs;
